import nl from './lang/nl';

export default { nl };
